import React from 'react';
import './welcome.css';
export const WelcomePage = (props: any): JSX.Element => {
	return (
		<div>




				<svg
					viewBox="0 0 1200 400"
					xmlns="http://www.w3.org/2000/svg"
					id={'mask-circle'}
					width={ 200 }
					height={ 200 }
				>
					<defs>
						<radialGradient id="borderGradient">
							<stop offset="0%" stopColor="#0000" />
							<stop offset="9%" stopColor="#0000" />
							<stop offset="10%" stopColor="#0001" />
							<stop offset="45%" stopColor="#000f" />
							<stop offset="50%" stopColor="#000f" />
							<stop offset="65%" stopColor="#000f" />
							<stop offset="70%" stopColor="#0000" />
							<stop offset="100%" stopColor="#0000" />
						</radialGradient>
						<mask id="mask">
							<circle
								id='maskInnerCircle'
								cx="50%"
								cy="50%"
								r="0"
								fill="url('#borderGradient')"
							/>
						</mask>

					</defs>

				</svg>


			<div className={'text-block-container'}>


				<div className={'text-block text-clear'}>
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
					Nel mezzo del cammin di nostra vita mi ritrovai per una selva oscura che la dritta via era smarrita.
				</div>

				<div className={'text-block text-digest animated-masked'}>
					TmVsIG1lenpvIGRlbCBjYW1taW4gZGkgbm9zdHJhIHZpdGEgbWkgcml0cm92YWkgcGVyIHVuYSBzZWx2YSBvc2N1cmEgY2hlIGxh
					IGRyaXR0YSB2aWEgZXJhIHNtYXJyaXRhLiBOZWwgbWV6em8gZGVsIGNhbW1pbiBkaSBub3N0cmEgdml0YSBtaSByaXRyb3ZhaSBw
					ZXIgdW5hIHNlbHZhIG9zY3VyYSBjaGUgbGEgZHJpdHRhIHZpYSBlcmEgc21hcnJpdGEuIE5lbCBtZXp6byBkZWwgY2FtbWluIGRp
					IG5vc3RyYSB2aXRhIG1pIHJpdHJvdmFpIHBlciB1bmEgc2VsdmEgb3NjdXJhIGNoZSBsYSBkcml0dGEgdmlhIGVyYSBzbWFycml0
					YS4gTmVsIG1lenpvIGRlbCBjYW1taW4gZGkgbm9zdHJhIHZpdGEgbWkgcml0cm92YWkgcGVyIHVuYSBzZWx2YSBvc2N1cmEgY2hl
					IGxhIGRyaXR0YSB2aWEgZXJhIHNtYXJyaXRhLiBOZWwgbWV6em8gZGVsIGNhbW1pbiBkaSBub3N0cmEgdml0YSBtaSByaXRyb3Zh
					aSBwZXIgdW5hIHNlbHZhIG9zY3VyYSBjaGUgbGEgZHJpdHRhIHZpYSBlcmEgc21hcnJpdGEuIE5lbCBtZXp6byBkZWwgY2FtbWlu
					IGRpIG5vc3RyYSB2aXRhIG1pIHJpdHJvdmFpIHBlciB1bmEgc2VsdmEgb3NjdXJhIGNoZSBsYSBkcml0dGEgdmlhIGVyYSBzbWFy
					cml0YS4gTmVsIG1lenpvIGRlbCBjYW1taW4gZGkgbm9zdHJhIHZpdGEgbWkgcml0cm92YWkgcGVyIHVuYSBzZWx2YSBvc2N1cmEg
					Y2hlIGxhIGRyaXR0YSB2aWEgZXJhIHNtYXJyaXRhLiBOZWwgbWV6em8gZGVsIGNhbW1pbiBkaSBub3N0cmEgdml0YSBtaSByaXRy
					b3ZhaSBwZXIgdW5hIHNlbHZhIG9zY3VyYSBjaGUgbGEgZHJpdHRhIHZpYSBlcmEgc21hcnJpdGEuIE5lbCBtZXp6byBkZWwgY2Ft
					bWluIGRpIG5vc3RyYSB2aXRhIG1pIHJpdHJvdmFpIHBlciB1bmEgc2VsdmEgb3NjdXJhIGNoZSBsYSBkcml0dGEgdmlhIGVyYSBz
					bWFycml0YS4gTmVsIG1lenpvIGRlbCBjYW1taW4gZGkgbm9zdHJhIHZpdGEgbWkgcml0cm92YWkgcGVyIHVuYSBzZWx2YSBvc2N1
					cmEgY2hlIGxhIGRyaXR0YSB2aWEgZXJhIHNtYXJyaXRhLiBOZWwgbWV6em8gZGVsIGNhbW1pbiBkaSBub3N0cmEgdml0YSBtaSBy
					aXRyb3ZhaSBwZXIgdW5hIHNlbHZhIG9zY3VyYSBjaGUgbGEgZHJpdHRhIHZpYSBlcmEgc21hcnJpdGEuIE5lbCBtZXp6byBkZWwg
					Y2FtbWluIGRpIG5vc3RyYSB2aXRhIG1pIHJpdHJvdmFpIHBlciB1bmEgc2VsdmEgb3NjdXJhIGNoZSBsYSBkcml0dGEgdmlhIGVy
					YSBzbWFycml0YS4gTmVsIG1lenpvIGRlbCBjYW1taW4gZGkgbm9zdHJhIHZpdGEgbWkgcml0cm92YWkgcGVyIHVuYSBzZWx2YSBv
					c2N1cmEgY2hlIGxhIGRyaXR0YSB2aWEgZXJhIHNtYXJyaXRhLiBOZWwgbWV6em8gZGVsIGNhbW1pbiBkaSBub3N0cmEgdml0YSBt
					c2FtbWluIGRpIG5vc3RyYSB2aXRhIG1pIHJpdHJvdmFpIHBlciB1bmEgc2VsdmEgb3NjdXJhIGNoZSBsYSBkcml0dGEgdmlhIGVy
					YSBzbWFycml0YS4gTmVsIG1lenpvIGRlbCBjYW1taW4gZGkgbm9zdHJhIHZpdGEgbWkgcml0cm92YWkgcGVyIHVuYSBzZWx2YSBv
					c2N1cmEgY2hlIGxhIGRyaXR0YSB2aWEgZXJhIHNtYXJyaXRhLiBOZWwgbWV6em8gZGVsIGNhbW1pbiBkaSBub3N0cmEgdml0YSBt
					c2N1cmEgY2hlIGxhIGRyaXR0YSB2aWEgZXJhIHNtYXJyaXRhLiBOZWwgbWV6em8gZGVsIGNhbW1pbiBkaSBub3N0cmEgdml0YSBt
					c2N1cmEgY2hlIGxhIGRyaXR0YSB2aWEgZXJhIHNtYXJyaXRhLiBOZWwgbWV6em8gZGVsIGNhbW1pbiBkaSBub3N0cmEgdml0YSBt
				</div>

			</div>

			{/*<div className={'crypto-panel-icon'}>*/}
			{/*	<img*/}
			{/*		src={'/imgs/red-locked.png'}*/}
			{/*	/>*/}
			{/*	<div>Secure</div>*/}
			{/*</div>*/}

		</div>
	);
}
